"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var debug = require("debug")("knack.formatter.formatters.number");
var numberRegex = new RegExp(/[^0-9.-]+/, "g");
var thousandsRegex = /(\d+)(\d{3})/;
var addCommas = function addCommas(num, format) {
  if (format.show_commas && _typeof(format.mark_thousands) === "undefined" || format.mark_thousands && format.mark_thousands !== "none") {
    if (!format.mark_thousands) {
      format.mark_thousands = "comma";
    }
    var decimalPlace = ".";
    var markThousands = format.mark_thousands || ",";
    switch (markThousands) {
      case "comma":
        markThousands = ",";
        break;
      case "space":
        markThousands = " ";
        break;
      case "period":
        markThousands = ".";
        break;
    }
    num = String(num);
    var _num$split = num.split(decimalPlace),
      _num$split2 = _slicedToArray(_num$split, 2),
      whole = _num$split2[0],
      fractional = _num$split2[1];
    var fractionalWithDecimal = fractional ? "".concat(decimalPlace).concat(fractional) : "";
    while (thousandsRegex.test(whole)) {
      whole = whole.replace(thousandsRegex, "$1".concat(markThousands, "$2"));
    }
    return "".concat(whole).concat(fractionalWithDecimal);
  }
  return num;
};
var addPrefixOrPostfix = function addPrefixOrPostfix(num, format) {
  if (format.format && format.format.toLowerCase() !== "none") {
    switch (format.format) {
      case "custom":
        format.pre = format.pre || "";
        format.post = format.post || "";
        num = String(format.pre) + num + String(format.post);
        break;
      case "euro_after":
      case "\u20AC_after":
        num = "".concat(num, "&nbsp;\u20AC");
        break;
      case "%":
        num = "".concat(num, "%");
        break;
      default:
        var neg = String(num).indexOf("-") > -1;
        num = String(format.format) + num;
        if (neg) {
          num = num.replace("".concat(format.format, "-"), "-".concat(format.format));
        }
        break;
    }
  } else if (format.prefix && format.prefix.toLowerCase() !== "none") {
    num = String(format.prefix) + num;
  }
  return num;
};
var markDecimals = function markDecimals(num, format) {
  // decimal comma format
  if (format.mark_decimal && format.mark_decimal === "comma" && format.precision && !isNaN(format.precision) && Number(format.precision) > 0) {
    var parts = String(num).split(".");

    // if the parts length is 1, that means we will display the whole number as a decimal
    if (parts.length > 1) {
      var decimal = parts.pop();
      num = "".concat(parts.join("."), ",").concat(decimal);
    }
  }
  return num;
};
var roundNumber = function roundNumber(num, format) {
  if (format.rounding && (format.rounding === "up" || format.rounding === "down")) {
    var multiplier = "1";
    for (var i = 0; i < format.precision; i++) {
      multiplier += "0";
    }
    var m = Number(multiplier);
    if (format.rounding === "up") {
      num = Math.ceil(num * m) / m;
    } else {
      num = Math.floor(num * m) / m;
    }
  }
  if (format.precision && (!format.mark_decimal || format.mark_decimal !== "none") || format.format === "%") {
    var precision = Number(format.precision);
    if (isNaN(precision)) {
      precision = 0;
    }
    if (format.format === "%") {
      precision += 2;
    }
    var precisionDecimals = Math.pow(10, precision);
    num = Math.round(num * precisionDecimals) / precisionDecimals;
    if (format.format === "%") {
      precision -= 2;
    }
    num = num.toFixed(precision);
    if (num === "-0") {
      num = "0";
    }
    return num;
  }
  return Math.round(num);
};

/**
 * @alias "formatters.number"
 * @param {String} value
 * @param {Object} [format]
 * @param {String} [format.format] Used for determining prefix / postfix, valid values: 'custom', '€_after', '%'
 * @param {String} [format.pre] Prefix if `format.format` == 'custom'
 * @param {String} [format.post] Postfix if `format.format` == 'custom'
 * @param {String} [format.prefix] Prefix if `format.prefix` !== 'none'
 * @param {String} [format.mark_thousands] Thousands delimiter, valid values: 'space', 'dot', 'comma'
 * @param {String} [format.mark_decimal] Decimal delimiter, valid values: 'dot', 'comma'
 * @param {Number} [format.precision] Number of decimal places to retain
 * @param {String} [format.rounding] Rounding preference, valid values: 'up', 'down'
 * @return {String}
 */
var numberFormatter = function numberFormatter(value, format) {
  var num = Number(String(value).replace(numberRegex, ""));
  if (!format) {
    format = {};
  }
  if (!num && num !== 0) {
    return "";
  }
  if (format.format && format.format === "%") {
    num = num * 100;
  }
  num = roundNumber(num, format);
  num = addCommas(num, format);
  num = addPrefixOrPostfix(num, format);
  num = markDecimals(num, format);
  return num;
};
module.exports = numberFormatter;